<template>
  <section class="tech-items">
    <div class="item-tech">
        <div class="title">
            <i class="el-icon-video-camera" style="color: #bc65d6; font-size: 30px; position: relative; top: 4px;"></i>
            <i>世说”新“语Newords2022——朱雷老师专访</i>
        </div>
	    <video-player  class="vjs-custom-skin"
                     ref="videoPlayer"
                     :playsinline="true"
                     :options="playerOptions1"
                     @play="onPlayerPlay($event)"
                     @pause="onPlayerPause($event)"
      >
      </video-player>
    </div>
    
    <div class="item-tech">
         <div class="title">
            <i class="el-icon-video-camera" style="color: #bc65d6; font-size: 30px; position: relative; top: 4px;"></i>
            <i>世说”新“语Newords2022——解玉琪老师专访</i>
         </div>
	     <video-player  class="vjs-custom-skin"
                     ref="videoPlayer"
                     :playsinline="true"
                     :options="playerOptions2"
                     @play="onPlayerPlay($event)"
                     @pause="onPlayerPause($event)"
      >
      </video-player>
    </div>
   
    <div class="item-tech">
         <div class="title">
            <i class="el-icon-video-camera" style="color: #bc65d6; font-size: 30px; position: relative; top: 4px;"></i>
            <i>世说”新“语Newords2022——辛善超老师专访</i>
         </div>
	     <video-player  class="vjs-custom-skin"
                     ref="videoPlayer"
                     :playsinline="true"
                     :options="playerOptions3"
                     @play="onPlayerPlay($event)"
                     @pause="onPlayerPause($event)"
      >
      </video-player>
    </div>
    
    <div class="item-tech">
         <div class="title">
            <i class="el-icon-video-camera" style="color: #bc65d6; font-size: 30px; position: relative; top: 4px;"></i>
            <i>世说”新“语Newords2022——杨志疆老师专访</i>
         </div>
	     <video-player  class="vjs-custom-skin"
                     ref="videoPlayer"
                     :playsinline="true"
                     :options="playerOptions4"
                     @play="onPlayerPlay($event)"
                     @pause="onPlayerPause($event)"
      >
      </video-player>
    </div>
 
  </section>
</template>




<script>
import { videoPlayer } from 'vue-video-player'
import 'video.js/dist/video-js.css'

export default {
  components: {
    videoPlayer
  },
  data () {
    return {
      playerOptions1: {
        height: '360',
        autoplay: false,
        muted: false,
        loop: false,
        preload: 'auto',
        language: 'zh-CN',
        aspectRatio: '16:9',
        fluid: true,
        notSupportedMessage: '此视频无法播放，请稍后再试',
        sources: [{
            type: 'video/mp4',
            src: 'http://archirookies.com/assets/upload/videos/zhulei.mp4'
        }],
        poster: 'http://archirookies.com/assets/upload/videos/zhulei.jpg' 
      },
      playerOptions2: {
        height: '360',
        autoplay: false,
        muted: false,
        loop: false,
        preload: 'auto',
        language: 'zh-CN',
        aspectRatio: '16:9',
        fluid: true,
        notSupportedMessage: '此视频无法播放，请稍后再试',
        sources: [{
            type: 'video/mp4',
            src: 'http://archirookies.com/assets/upload/videos/jieyuqi.mp4'
        }],
        poster: 'http://archirookies.com/assets/upload/videos/jieyuqi.jpg' 
      },
      playerOptions3: {
        height: '360',
        autoplay: false,
        muted: false,
        loop: false,
        preload: 'auto',
        language: 'zh-CN',
        aspectRatio: '16:9',
        fluid: true,
        notSupportedMessage: '此视频无法播放，请稍后再试',
        sources: [{
            type: 'video/mp4',
            src: 'http://archirookies.com/assets/upload/videos/xinshanchao.mp4'
        }],
        poster: 'http://archirookies.com/assets/upload/videos/xinshanchao.jpg' 
      },
      playerOptions4: {
        height: '360',
        autoplay: false,
        muted: false,
        loop: false,
        preload: 'auto',
        language: 'zh-CN',
        aspectRatio: '16:9',
        fluid: true,
        notSupportedMessage: '此视频无法播放，请稍后再试',
        sources: [{
            type: 'video/mp4',
            src: 'http://archirookies.com/assets/upload/videos/yangzhijiang.mp4'
        }],
        poster: 'http://archirookies.com/assets/upload/videos/yangzhijiang.jpg' 
      }
      
    } 
  },
  computed: {
    player () {
      return this.$refs.videoPlayer.player
    }
  },
  mounted(){
  },
  methods: {
    onPlayerPlay (player) {
    },
    onPlayerPause (player) {
    }
  }
}
</script>

<style scoped lang='stylus' rel="stylesheet/stylus">
@import '~@/common/stylus/index'

.tech-items {
    padding: 0 calc((100% - 800px) /2);
    margin-top: 60px;
}
.item-tech {
  width: 800px;
  margin: 0 auto;
  margin-bottom: 2em;
}
.item-tech > div{
  flex: none;
}
.title {
    text-align: left;
    font-size: 22px;
    margin-bottom: 20px;
}
</style>
<style>
.video-js .vjs-big-play-button{
  top: calc(50% - 20px) !important;
  left: calc(50% - 50px) !important;
}
.vjs-custom-skin {
  border: 1px solid #bc65d6;
}
</style>



// WEBPACK FOOTER //
// Interview.vue?726cbff6